/**
 * Collection shop cards — hover video, load remaining products, AJAX category tabs.
 * Instant tab/hero feedback; fetches only the product grid for speed.
 */
(function () {
  'use strict';

  var loadingClass = 'is-loading';
  var enteringClass = 'is-entering';
  var activeController = null;
  var loadToken = 0;

  function bindCardHover(card) {
    if (!card || !card.classList.contains('shop-by-need__card--has-hover')) return;
    if (card.dataset.hoverBound === 'true') return;
    card.dataset.hoverBound = 'true';

    var link = card.querySelector('.shop-by-need__card-link');
    var video = card.querySelector('.shop-by-need__card-video');
    if (!link) return;

    var playVideo = function () {
      if (video && typeof video.play === 'function') {
        var playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {});
        }
      }
    };

    var pauseVideo = function () {
      if (video && typeof video.pause === 'function') {
        video.pause();
        try {
          video.currentTime = 0;
        } catch (e) {}
      }
    };

    link.addEventListener('mouseenter', function () {
      card.classList.add('is-hover');
      playVideo();
    });

    link.addEventListener('mouseleave', function () {
      card.classList.remove('is-hover');
      pauseVideo();
    });

    link.addEventListener('focusin', function () {
      card.classList.add('is-hover');
      playVideo();
    });

    link.addEventListener('focusout', function () {
      card.classList.remove('is-hover');
      pauseVideo();
    });
  }

  function normalizePath(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      var path = parsed.pathname.replace(/\/+$/, '');
      return path || '/';
    } catch (e) {
      return url;
    }
  }

  function productIdFromItem(item) {
    if (!item) return '';
    if (item.dataset && item.dataset.gridProductId) return item.dataset.gridProductId;
    var card = item.querySelector('[data-product-id]');
    return card ? card.dataset.productId : '';
  }

  function existingIds(grid) {
    var ids = {};
    grid.querySelectorAll('[data-product-id], [data-grid-product-id]').forEach(function (el) {
      var id = el.dataset.productId || el.dataset.gridProductId;
      if (id) ids[id] = true;
    });
    return ids;
  }

  function parseSection(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function appendUniqueItems(grid, sourceRoot) {
    var ids = existingIds(grid);
    var items = sourceRoot.querySelectorAll('.collection-shop-cards__item');
    items.forEach(function (item) {
      if (item.classList.contains('collection-shop-cards__item--empty')) return;
      var id = productIdFromItem(item);
      if (id && ids[id]) return;
      if (id) ids[id] = true;
      var imported = document.importNode(item, true);
      grid.appendChild(imported);
      var card = imported.querySelector('[data-product-card]');
      if (card) bindCardHover(card);
    });
  }

  function sectionUrl(collectionUrl, sectionId, page) {
    var url = new URL(collectionUrl, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    if (page) url.searchParams.set('page', String(page));
    return url.toString();
  }

  function hidePagination(root) {
    var pagination = root.querySelector('[data-collection-pagination]');
    if (pagination) pagination.remove();
  }

  function routesRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function fetchPublishedProducts(page, collected) {
    page = page || 1;
    collected = collected || [];

    return fetch(routesRoot() + 'products.json?limit=250&page=' + page, {
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load products');
        return res.json();
      })
      .then(function (data) {
        var products = (data && data.products) || [];
        var next = collected.concat(products);
        if (products.length === 250) {
          return fetchPublishedProducts(page + 1, next);
        }
        return next;
      });
  }

  function appendCardHtml(grid, html) {
    if (!html || !grid) return;
    appendUniqueItems(grid, parseSection(html));
  }

  function collectCatalogProducts() {
    var requests = [
      fetchPublishedProducts().catch(function () {
        return [];
      }),
    ];

    document.querySelectorAll('[data-collection-tab]').forEach(function (tab) {
      var href = tab.getAttribute('href');
      if (!href || href === '#') return;

      try {
        var collectionUrl = new URL(href, window.location.origin);
        var path = collectionUrl.pathname.replace(/\/+$/, '');
        requests.push(
          fetch(path + '/products.json?limit=250', { credentials: 'same-origin' })
            .then(function (res) {
              if (!res.ok) return { products: [] };
              return res.json();
            })
            .then(function (data) {
              return (data && data.products) || [];
            })
            .catch(function () {
              return [];
            })
        );
      } catch (e) {}
    });

    return Promise.all(requests).then(function (groups) {
      var map = {};
      groups.forEach(function (products) {
        products.forEach(function (product) {
          if (product && product.id) {
            map[String(product.id)] = product;
          }
        });
      });
      return Object.keys(map).map(function (id) {
        return map[id];
      });
    });
  }

  function fillMissingPublishedProducts(root) {
    if (!root || root.dataset.loadAllPublished !== 'true') {
      return Promise.resolve();
    }

    var grid = root.querySelector('[data-collection-container]');
    var view = root.dataset.productCardView || 'card';
    if (!grid) return Promise.resolve();

    return collectCatalogProducts()
      .then(function (products) {
        var ids = existingIds(grid);
        var missing = products.filter(function (product) {
          return product && product.handle && product.id && !ids[String(product.id)];
        });

        if (!missing.length) return;

        return Promise.all(
          missing.map(function (product) {
            return fetch(routesRoot() + 'products/' + encodeURIComponent(product.handle) + '?view=' + encodeURIComponent(view), {
              credentials: 'same-origin',
            }).then(function (res) {
              if (!res.ok) return '';
              return res.text();
            });
          })
        ).then(function (htmls) {
          htmls.forEach(function (html) {
            appendCardHtml(grid, html);
          });
        });
      })
      .catch(function () {});
  }

  function loadRemainingPages(root) {
    var pages = parseInt(root.dataset.pages, 10) || 1;
    var page = parseInt(root.dataset.page, 10) || 1;
    var sectionId = root.dataset.ajaxSectionId;
    var collectionUrl = root.dataset.collectionUrl;
    var grid = root.querySelector('[data-collection-container]');

    hidePagination(root);

    if (!grid || !sectionId || !collectionUrl || page >= pages) {
      return Promise.resolve();
    }

    var fetches = [];
    for (var p = page + 1; p <= pages; p++) {
      fetches.push(
        fetch(sectionUrl(collectionUrl, sectionId, p), { credentials: 'same-origin' }).then(function (res) {
          if (!res.ok) throw new Error('Failed to load products');
          return res.text();
        })
      );
    }

    return Promise.all(fetches)
      .then(function (htmls) {
        htmls.forEach(function (html) {
          appendUniqueItems(grid, parseSection(html));
        });
      })
      .catch(function () {});
  }

  function isAllCollectionUrl(url) {
    var path = normalizePath(url).toLowerCase();
    return path === '/collections/all' || /\/collections\/all$/.test(path);
  }

  function tabLabelForUrl(url) {
    if (isAllCollectionUrl(url)) return 'SHOP ALL';

    var path = normalizePath(url);
    var label = '';
    document.querySelectorAll('[data-ajax-collection-tabs] .icon-text-links__item').forEach(function (item) {
      if (normalizePath(item.getAttribute('href') || '') === path) {
        label = (item.textContent || '').replace(/\s+/g, ' ').trim();
      }
    });
    return label;
  }

  function setActiveTab(url) {
    var path = normalizePath(url);

    document.querySelectorAll('[data-ajax-collection-tabs] .icon-text-links__item').forEach(function (item) {
      var href = item.getAttribute('href') || '';
      var active = normalizePath(href) === path;
      item.classList.toggle('is-active', active);
      if (active) {
        item.setAttribute('aria-current', 'page');
        var scroller = item.closest('[data-icon-text-links-scroller]');
        if (scroller) {
          var max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
          var target = item.offsetLeft - (scroller.clientWidth - item.offsetWidth) / 2;
          scroller.scrollTo({ left: Math.min(max, Math.max(0, target)), behavior: 'smooth' });
        }
      } else {
        item.removeAttribute('aria-current');
      }
    });
  }

  function updateHeroSubtitle(label) {
    // Only touch opted-in collection heroes — never other pages or duplicate banners
    var nodes = document.querySelectorAll(
      '[data-ajax-collection-section][data-section-type="hero-banner"] [data-ajax-collection-subtitle]'
    );
    if (!nodes.length || !label) return;

    nodes.forEach(function (el) {
      if ((el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase() === label.toLowerCase()) {
        return;
      }

      el.classList.add('is-fading');
      window.setTimeout(function () {
        el.textContent = label;
        el.classList.remove('is-fading');
      }, 120);
    });
  }

  function updateDocumentTitle(label) {
    if (!label) return;
    if (!document.getElementById('CollectionGrid')) return;
    var parts = (document.title || '').split(/\s+[–—|-]\s+/);
    if (parts.length > 1) {
      document.title = label + ' – ' + parts.slice(1).join(' – ');
    } else {
      document.title = label;
    }
  }

  function applyInstantCollectionUi(collectionUrl) {
    if (!document.getElementById('CollectionGrid')) return;
    if (!document.querySelector('[data-ajax-collection-tabs]')) return;

    var label = tabLabelForUrl(collectionUrl);
    setActiveTab(collectionUrl);
    updateHeroSubtitle(label);
    updateDocumentTitle(label);
  }

  function replaceGrid(html) {
    var doc = parseSection(html);
    var incoming = doc.getElementById('CollectionGrid') || doc.querySelector('[data-collection-shop-cards]');
    var current = document.getElementById('CollectionGrid');
    if (!incoming || !current) return null;

    var imported = document.importNode(incoming, true);
    imported.classList.add(enteringClass);
    current.replaceWith(imported);

    var next = document.getElementById('CollectionGrid');
    if (next) {
      void next.offsetWidth;
      requestAnimationFrame(function () {
        next.classList.remove(enteringClass);
      });
      initRoot(next);
    }
    return next;
  }

  function clearLoading(grid) {
    if (!grid) return;
    grid.dataset.loading = '';
    grid.classList.remove(loadingClass);
    grid.removeAttribute('aria-busy');
  }

  function loadCollection(collectionUrl, options) {
    options = options || {};
    var current = document.getElementById('CollectionGrid');
    if (!current) return Promise.resolve();
    var sectionId = current.dataset.ajaxSectionId;
    if (!sectionId) return Promise.resolve();

    if (activeController) {
      try {
        activeController.abort();
      } catch (e) {}
    }
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    activeController = controller;
    var token = ++loadToken;

    applyInstantCollectionUi(collectionUrl);

    if (options.updateHistory !== false) {
      var nextUrl = new URL(collectionUrl, window.location.origin);
      history.pushState({ collectionShopCards: true }, '', nextUrl.pathname + nextUrl.search);
    }

    current.dataset.loading = 'true';
    current.classList.add(loadingClass);
    current.setAttribute('aria-busy', 'true');

    var fetchUrl = sectionUrl(collectionUrl, sectionId);
    var fetchOpts = { credentials: 'same-origin' };
    if (controller) fetchOpts.signal = controller.signal;

    return fetch(fetchUrl, fetchOpts)
      .then(function (res) {
        if (!res.ok) throw new Error('Section fetch failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        if (token !== loadToken) return;
        replaceGrid(html);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (token !== loadToken) return;
        console.error('[collection-shop-cards] AJAX failed:', err, fetchUrl);
        window.location.href = collectionUrl;
      })
      .finally(function () {
        if (token !== loadToken) return;
        if (activeController === controller) activeController = null;
        clearLoading(document.getElementById('CollectionGrid'));
      });
  }

  function initRoot(root) {
    if (!root) return;

    var cards = root.querySelectorAll('[data-product-card]');
    cards.forEach(bindCardHover);
    loadRemainingPages(root).then(function () {
      return fillMissingPublishedProducts(root);
    });
  }

  function onTabClick(event) {
    if (event.button !== undefined && event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var tab = event.target.closest('[data-collection-tab]');
    if (!tab) return;
    if (!tab.closest('[data-ajax-collection-tabs]')) return;
    if (!document.getElementById('CollectionGrid')) return;

    var href = tab.getAttribute('href');
    if (!href || href === '#') return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (normalizePath(window.location.href) === normalizePath(href)) return;

    loadCollection(href);
  }

  function initAll() {
    document.querySelectorAll('[data-collection-shop-cards]').forEach(initRoot);
  }

  document.addEventListener('click', onTabClick, true);

  window.addEventListener('popstate', function () {
    if (!document.getElementById('CollectionGrid')) return;
    loadCollection(window.location.href, { updateHistory: false });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    var root = event.target.querySelector
      ? event.target.querySelector('[data-collection-shop-cards]')
      : null;
    if (root) initRoot(root);
  });
})();
